<template>
    <not-found-view v-if="error" :error500="true"></not-found-view>

    <div v-else class="quiz">
        <div class="grid grid--padding">
            <quiz-start v-if="$route.name == 'quiz-start'" :quiz="quiz" :isDataLoading="$apollo.loading"></quiz-start>

            <quiz-result v-else-if="$route.name == 'quiz-results'" 
                :score="quizScore" 
                :total="totalQuestionsCount" 
                :isDataLoading="$apollo.loading" 
                @reset="resetQuiz"
            >
            </quiz-result>

            <quiz-questions v-else 
                :question="currentQuestion" 
                :answers="currentAnswers" 
                :checkAnswer="checkAnswer"
                :addClasses="addClasses" 
                :disable="disableButtons"
                :progressTotalCount="totalQuestionsCount" 
                :progressCurrent="activeQuestion"
                :isDataLoading="$apollo.loading"
            >
            </quiz-questions>
        </div>
    </div>
</template>

<script>
import { getQuizListing } from '@/queries/quizQueries.js';
import QuizStart from '@/components/quiz/QuizStart.vue';
import QuizQuestions from '@/components/quiz/QuizQuestions.vue';
import QuizResult from '@/components/quiz/QuizResult.vue';

export default {
    name: 'QuizView',
    components: {
        QuizStart,
        QuizQuestions,
        QuizResult
    },
    data() {
        return {
            error: false,
            getQuizListing: null,
            activeQuestion: 0,
            quizScore: 0,
            disableButtons: false,
            selectedAnswer: null
        }
    },
    apollo: {
        getQuizListing: {
            query: getQuizListing,
            error(error) {
                console.log('errors', error);
                this.error = true;
            }
        }
    },
    computed: {
        quiz() {
            return this.getQuizListing ? this.getQuizListing.edges[0].node : false;
        },
        totalQuestionsCount() {
            return this.getQuizListing ? this.quiz.questions.length : 0;
        },
        currentQuestion() {
            return this.getQuizListing ? this.quiz.questions[this.activeQuestion].Question : false;
        },
        currentAnswers() {
            return this.getQuizListing ? this.quiz.questions[this.activeQuestion].anwsers : false;
        }
    },
    methods: {
        checkAnswer(answer) {
            this.selectedAnswer = answer;
            this.disableButtons = true;

            this.currentAnswers.forEach(btn => {
                this.addClasses(btn);
            });

            if (answer.correctAnswer) {
                this.quizScore = this.quizScore + 1;
            }

            setTimeout(() => {
                this.selectedAnswer = null;
                this.disableButtons = false;

                if ((this.activeQuestion + 1) == this.totalQuestionsCount) {
                    this.$router.push({name: 'quiz-results'});
                } else {
                    this.activeQuestion = this.activeQuestion + 1;
                }
            }, 3000);
        },
        addClasses(answer) {
            if (this.selectedAnswer == answer && answer.correctAnswer) {
                return 'btn--correct';
            } else if (this.selectedAnswer == answer && !answer.correctAnswer) {
                return 'btn--wrong';
            } else if (this.selectedAnswer && this.selectedAnswer != answer && answer.correctAnswer) {
                return 'btn--correct';
            } else {
                return false;
            }
        },
        resetQuiz() {
            this.activeQuestion = 0;
            this.quizScore = 0;
            this.disableButtons = false;
            this.selectedAnswer = null;

            this.$router.push({name: 'quiz-start'});
        }
    },
    mounted() {
        const appHeight = () => {
            document.documentElement.style.setProperty('--app-height', `${(window.innerHeight - 56)}px`)
        };
        window.addEventListener('resize', appHeight);
        appHeight();
    }
}
</script>
